import { takeLeading, select } from 'redux-saga/effects';
import { callApi } from 'helpers/saga-helpers';
import { isNull } from 'lodash';
import { REQUEST_USAGE_CLAIMS } from 'containers/UsageClaimsPage/constants';
import { setUsageClaims } from 'containers/UsageClaimsPage/actions';
import { makeSelectKeycloakToken } from 'containers/AppContainer/selectors';

export function* requestUsageClaims(action: {
  page: number;
  pageSize: number;
  type: string;
}): Generator<unknown> {
  const { page, pageSize } = action;
  const token = yield select(makeSelectKeycloakToken());
  if (isNull(token)) return;
  const path = `/corporeal/common/usage-claims?page=${page}&pageSize=${pageSize}&isIntervenant=true`;
  const options = {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  yield callApi(path, {}, options, [], setUsageClaims);
}

export function* requestUsageClaimsSaga() {
  yield takeLeading(REQUEST_USAGE_CLAIMS, requestUsageClaims);
}

export default [requestUsageClaimsSaga];
